import React from 'react';

const DriverExpenseFilters = ({
  selectedMonth,
  selectedYear,
  selectedStatus,
  onMonthChange,
  onYearChange,
  onStatusChange,
  onAdd,
  activeTab,
  addDisabled = false,
}) => {
  const getMonthOptions = () => {
    return Array.from({ length: 12 }, (_, i) => ({
      label: new Date(0, i).toLocaleString('default', { month: 'long' }),
      value: (i + 1).toString().padStart(2, '0'),
    }));
  };

  const getYearOptions = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, i) => {
      const year = currentYear - i;
      return { label: year.toString(), value: year.toString() };
    });
  };

  const getStatusOptions = () => [
    { label: 'All', value: 'all' },
    { label: 'Approved', value: 'approved' },
    { label: 'Pending', value: 'pending' },
    { label: 'Rejected', value: 'rejected' },
  ];

  return (
    <div className="flex items-center justify-between flex-wrap gap-4 p-2 [&_select]:uppercase">
      <div className="flex gap-6 flex-wrap">
        {/* Month */}
        <div className="flex flex-col">
          <label className="text-sm font-medium">Month</label>
          <select
            value={selectedMonth}
            onChange={(e) => onMonthChange(e.target.value)}
            className="border px-2 py-1 rounded"
          >
            {getMonthOptions().map((month) => (
              <option key={month.value} value={month.value}>
                {month.label}
              </option>
            ))}
          </select>
        </div>

        {/* Year */}
        <div className="flex flex-col">
          <label className="text-sm font-medium">Year</label>
          <select
            value={selectedYear}
            onChange={(e) => onYearChange(e.target.value)}
            className="border px-2 py-1 rounded"
          >
            {getYearOptions().map((year) => (
              <option key={year.value} value={year.value}>
                {year.label}
              </option>
            ))}
          </select>
        </div>

        {/* Status */}
        {
          activeTab === 'expenses' &&
          <div className="flex flex-col">
            <label className="text-sm font-medium mb-1">Status</label>
            <select
              value={selectedStatus}
              onChange={(e) => onStatusChange(e.target.value)}
              className="border px-2 py-1 rounded"
            >
              {getStatusOptions().map((status) => (
                <option key={status.value} value={status.value}>
                  {status.label}
                </option>
              ))}
            </select>
          </div>
        }
      </div>

      <button
        onClick={onAdd}
        disabled={addDisabled}
        className={`px-4 py-1 rounded text-white ${addDisabled ? 'bg-gray-400 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700'}`}
      >
        + Add Expense
      </button>
    </div>
  );
};

export default DriverExpenseFilters;
